import { Loader, Table } from 'components'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Date, Hour, Store } from './CellComponents'

interface Props {
  data: any[]
  isFetching: boolean
}

function TableStores({ data, isFetching }: Props) {
  const { t: translate } = useTranslation()

  if (isFetching) {
    return <Loader />
  }

  const columns = [
    {
      key: 'store',
      title: translate('revenue.stats.completeness.company'),
      CellRender: Store,
    },
    {
      key: 'date',
      title: translate('common.date'),
      CellRender: Date,
    },
    {
      key: 'hour',
      title: translate('revenue.stats.completeness.hour'),
      CellRender: Hour,
    },
  ]

  return <Table columns={columns} data={data} tableClassName="completeness-details-table completeness-details-table_store" />
}

export default TableStores
